import styled from 'styled-components'

export const Container = styled.div`
  background: #fff;
  color: #513528;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  @media(min-width: 991px) {
    display: flex;
    height: 88px;
    border-bottom: 1px solid #DADADA;
    padding: 16px 24px;
    gap: 16px;
  }
`
export const GroupLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
export const Logo = styled.img`
  height: 32px;
`
export const Title = styled.h1`
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 400;
  line-height: 17.4px;
  margin: 0px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  gap: 8px;
  &:before {
    content: '';
    display: block;
    width: 1.3px;
    height: 24px;
    background-color: #513528;
  }
`
export const Badge = styled.span`
  display: block;
  width: 45px;
  height: 24px;
  padding: 3px 8px;
  border-radius: 8px;
  font-family: 'Open Sans';
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  background-color: #EDEDED;
  margin-bottom: 5px;
`
